import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Warehouse } from 'src/app/shared/types/warehouse.model';

@Component({
	selector: 'bt-pickup-modal',
	standalone: true,
	templateUrl: './pickup-modal.component.html',
	styleUrl: './pickup-modal.component.scss'
})
export class PickupModalComponent {
	data = inject<any>(MAT_DIALOG_DATA);
	loading = false;
	isDragging = false;

	constructor(private dialogRef: MatDialogRef<PickupModalComponent>) {
		console.log('PickupModalComponent data:', this.data);
	}

	close(): void {
		this.dialogRef.close();
	}
}
